import type { SVGProps } from 'react';
const DawnFlagMR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MR_svg__a)">
      <path fill="#108B4D" d="M0 0h22v16H0z" />
      <path
        fill="#FFC941"
        fillRule="evenodd"
        d="M15.568 6.187q.057.37.058.755c0 2.65-2.11 4.8-4.714 4.8s-4.715-2.15-4.715-4.8q0-.386.058-.755c.356 2.292 2.305 4.045 4.657 4.045 2.35 0 4.3-1.753 4.656-4.045M11 6.85l-1.295.94.478-1.544-1.278-.964 1.59-.014L11 3.733l.505 1.536 1.59.014-1.278.964.478 1.544z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMR;
